import { useEffect } from "react";
import SplashApp from "@/components/feature/SplashApp";
import ErroGlobal from "@/components/feature/ErroGlobal";
import { BrowserRouter } from "react-router-dom";
import { MotionConfig } from "motion/react";
import { AppRoutes } from "./router";
import { AuthProvider } from "@/hooks/useAuth";
import { ConvitesProvider } from "@/pages/convites/context";
import ConviteGlobal from "@/pages/convites/components/ConviteGlobal";
import ScrollToTop from "@/components/feature/ScrollToTop";
import FaixaNavegador from "@/components/feature/FaixaNavegador";
import PortaoApp from "@/components/feature/PortaoApp";
import PortaoCadastro from "@/components/feature/PortaoCadastro";
import ConviteAvisos from "@/components/feature/ConviteAvisos";
import ConviteWhatsapp from "@/components/feature/ConviteWhatsapp";
import ConviteTribo from "@/components/feature/ConviteTribo";
import { ProvedorModoEquipe, TravaModoEquipe, ForaDoModoEquipe } from "@/components/feature/ModoEquipe";
import { MinhaFotoProvider } from "@/hooks/useMinhaFoto";
import { supabase } from "@/lib/supabase";
import { descartarSessaoAntiga, ehRefreshTokenInvalido } from "@/lib/sessao";
import { iniciarRegistroAparelho } from "@/lib/aparelho";

function App() {
  // Registra a abertura do aparelho (logado ou não), sem travar a tela.
  useEffect(() => iniciarRegistroAparelho(), []);

  // Pedir ao celular para não apagar os dados do app quando a pessoa entra.
  useEffect(() => {
    const { data: sub } = supabase.auth.onAuthStateChange((event) => {
      if (event === 'SIGNED_IN') {
        void navigator.storage?.persist?.();
      }
    });
    return () => {
      sub.subscription.unsubscribe();
    };
  }, []);

  // Ao voltar o app para frente ou quando a internet volta, lê a sessão de novo
  // (o getSession renova o token se precisar). Isso NUNCA desloga: só mantém a
  // sessão viva. Nunca chamamos refreshSession manualmente.
  useEffect(() => {
    const renovar = () => {
      supabase.auth.getSession().catch((e: unknown) => {
        if (ehRefreshTokenInvalido(e)) void descartarSessaoAntiga();
      });
    };
    const aoVoltar = () => {
      if (document.visibilityState === 'visible') {
        renovar();
      }
    };
    const aoOnline = () => {
      renovar();
    };
    document.addEventListener('visibilitychange', aoVoltar);
    window.addEventListener('online', aoOnline);
    return () => {
      document.removeEventListener('visibilitychange', aoVoltar);
      window.removeEventListener('online', aoOnline);
    };
  }, []);

  return (
    <ErroGlobal>
      <MotionConfig reducedMotion="user">
        <AuthProvider>
          <BrowserRouter basename={__BASE_PATH__}>
            <ProvedorModoEquipe>
              <MinhaFotoProvider>
                <SplashApp />
                <ForaDoModoEquipe>
                  <FaixaNavegador />
                </ForaDoModoEquipe>
                <ConvitesProvider>
                  <ForaDoModoEquipe>
                    <ConviteGlobal />
                  </ForaDoModoEquipe>
                  <ScrollToTop />
                  <PortaoApp>
                    <TravaModoEquipe>
                      <AppRoutes />
                    </TravaModoEquipe>
                  </PortaoApp>
                  <ForaDoModoEquipe>
                    <PortaoCadastro />
                  </ForaDoModoEquipe>
                  <ConviteAvisos />
                  <ConviteTribo />
                  <ConviteWhatsapp />
                </ConvitesProvider>
              </MinhaFotoProvider>
            </ProvedorModoEquipe>
          </BrowserRouter>
        </AuthProvider>
      </MotionConfig>
    </ErroGlobal>
  );
}

export default App;